/** A muted dash for a roster cell with nothing to show. */
export default function StaffDash() {
  return <span className="text-xs text-stone-500 dark:text-stone-400">—</span>;
}
